import { isAdmin } from '@orientaction/utils';
import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useAlert from '../../../hooks/useAlert';
import { authenticateSSO } from '../../../services/user.service';
import locale from './locale.json';

const FacebookSSOCallback = () => {
  const { search } = useLocation();
  const history = useHistory();
  const processed = useRef(false);
  const alert = useAlert();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const handleError = (message: string) => {
      alert.openSimpleAlert(message);
      history.replace('/');
    };

    const params = new URLSearchParams(search);
    const providerAccessToken = params.get('access_token');
    const rawError = params.get('error');

    if (rawError) {
      handleError(locale.ssoProviderError);
      return;
    }

    if (!providerAccessToken) {
      handleError(locale.missingProviderToken);
      return;
    }

    (async () => {
      try {
        const response = await authenticateSSO('facebook', providerAccessToken);
        const { jwt, user } = response.data;

        if (!jwt || !user?.id) {
          handleError(locale.invalidUserData);
          return;
        }

        if(!user.phone || !user.postal_code) {
          sessionStorage.setItem('ssoData', JSON.stringify({ jwt, user }));
          history.replace('/signup?sso=true');
          return;
        }

        localStorage.setItem('userToken', jwt);
        localStorage.setItem('userInfos', JSON.stringify(user));

        if (isAdmin(user)) {
          const services = user?.allowed_services?.map((s: { id: number }) => s.id) ?? [];
          if (services.length === 1 && services[0] === 4) {
            history.replace('/admin/emploi/board');
            return;
          }
          history.replace('/admin/users-resultats');
          return;
        }

        history.replace('/main');
      } catch (err: any) {
        const backendMessage = err?.response?.data?.error?.message;
        const message =
          backendMessage === 'Email already taken'
            ? locale.emailAlreadyTaken
            : backendMessage ?? locale.ssoConnectionError;
        handleError(message);
      }
    })();
  }, [search, history, alert]);

  return null;
};

export default FacebookSSOCallback;